import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    Button,
    Fade,
    IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import MUIModalButtonStyles from './MUIStyles/MUIModalButtonStyles';

const MUIModal =
    ({
        open,
        onClose,
        closeLabel = 'Close',
        title,
        onSubmit,
        children,
        maxWidth = 'md',
        fullWidth = true,
        zIndex = 1500,

        // Optional default buttons
        showDefaultButtons = false,
        cancelLabel = 'Cancel',
        submitLabel = 'Submit',
        onCancel,
        submitButtonProps = {},
        cancelButtonProps = {},

        // Custom actions buttons
        customActions = null
    }) => {
        return (
            <Dialog
                open={open}
                onClose={onClose}
                fullWidth={fullWidth}
                maxWidth={maxWidth}
                TransitionComponent={Fade}
                transitionDuration={300}
                sx={{ zIndex: zIndex }}
                backdropClassName={zIndex ? "backdrop-override" : ""}
                PaperProps={{
                    component: 'form',
                    onSubmit: (e) => {
                        e.preventDefault();
                        if (onSubmit) onSubmit(e);
                    },
                    sx: {
                        boxShadow: 6,
                        borderRadius: 2,
                        backgroundColor: '#FFFFFF',
                    },
                    onSubmit: onSubmit,
                    className: "dialog",
                }}
            >
                <DialogTitle
                    sx={{
                        backgroundColor: '#eeeeee',
                        textAlign: 'center',
                        padding: '24px',
                        position: 'relative'
                    }}
                >
                    <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#172B42' }}>
                        {title}
                    </Typography>

                    <IconButton
                        aria-label={closeLabel}
                        onClick={onClose}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: 'grey.500',
                        }}
                    >
                        <CloseIcon fontSize="large" />
                    </IconButton>

                </DialogTitle>

                <DialogContent sx={{ padding: '32px', verflow: 'visible' }} style={{ paddingTop: '4rem' }}>
                    {children}
                </DialogContent>

                <DialogActions sx={{ padding: '24px', justifyContent: 'right' }}>
                    {customActions ? (
                        customActions
                    ) : showDefaultButtons ? (
                        <>
                            <Button
                                type="button"
                                onClick={onCancel || onClose}
                                sx={MUIModalButtonStyles}
                                {...cancelButtonProps}
                            >
                                {cancelLabel}
                            </Button>

                            {/* Only show submit if explicitly allowed */}
                            {submitLabel && (
                                <Button
                                        type="submit"
                                        sx={MUIModalButtonStyles}
                                    {...submitButtonProps}
                                >
                                    {submitLabel}
                                </Button>
                            )}
                        </>
                    ) : null}
                </DialogActions>
            </Dialog>
        );
    };

export default MUIModal;
